import { Flower2, CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OptimizedImageByName from '../common/OptimizedImageByName';

export const SendAsGiftSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSendGift = () => {
    navigate('/gift-subscription');
  };

  return (
    <section
      id="sendAsGift-panel"
      role="region"
      aria-labelledby="sendAsGift-heading"
      tabIndex={0}
      aria-label="Send flowers as a gift"
      className="py-16 px-6"
      style={{ backgroundColor: '#FEFDEA' }}
    >
      <div className="max-w-md mx-auto space-y-6">
        <h2 id="sendAsGift-heading" className="text-3xl font-bold mb-6 text-center text-gray-900">
          {t('common.sendAsGift.title')}
        </h2>

        <div className="space-y-4 mb-6">
          {/* Actual Flower Delivery Option */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-transparent">
            <div className="flex-shrink-0 w-16 h-16 rounded-lg flex items-center justify-center">
              <OptimizedImageByName
                imageName="bouquetGift"
                alt={t('common.sendAsGift.bouquetGift.alt')}
                className="w-16 h-16 object-contain"
              />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                {t('common.sendAsGift.actualDelivery.title')}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {t('common.sendAsGift.actualDelivery.description')}
              </p>
            </div>
          </div>

          {/* Gift Code Option */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-transparent">
            <div className="flex-shrink-0 w-16 h-16 rounded-lg flex items-center justify-center">
              <OptimizedImageByName
                imageName="couponGift"
                alt={t('common.sendAsGift.giftCode.alt')}
                className="w-16 h-16 object-contain"
              />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                {t('common.sendAsGift.giftCode.title')}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {t('common.sendAsGift.giftCode.description')}
              </p>
            </div>
          </div>
        </div>

        {/* image */}
        <div className="mb-6">
          <OptimizedImageByName
            imageName="giftImg"
            alt={t('common.sendAsGift.giftImage.alt')}
            className="w-full rounded-2xl aspect-[4/3] object-cover shadow-sm"
          />
        </div>

        {/* Send a Gift Button */}
        <div className="text-center pt-2">
          <button
            onClick={handleSendGift}
            className="w-fit bg-orange-400 hover:bg-orange-500 text-white font-semibold py-4 px-20 rounded-full shadow-md transform transition-all duration-200 hover:scale-[1.02] focus:outline-none"
          >
            {t('common.sendAsGift.sendButton')}
          </button>
        </div>
      </div>
    </section>
  );
}; 